import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";

const OrderDetail = () => {
  const { orderId } = useParams();
  const [orderStatus, setOrderStatus] = useState("En traitement");

  const orderItems = [
    {
      id: 1,
      name: "IPol Pro S6 5G",
      image: "/images/app.png",
      badges: ["256 GB", "Black"],
      orderId: "#OD24321",
      quantity: 1,
      price: 55000,
      originalPrice: 55000,
      isDiscounted: false
    },
    {
      id: 2,
      name: "TWS Earphone M1",
      image: "/images/ecouteur.png",
      badges: ["Black"],
      orderId: "#OD24321",
      quantity: 1,
      price: 20000,
      originalPrice: 65000,
      isDiscounted: true
    },
    {
      id: 3,
      name: "Earphone G1",
      image: "/images/ecouteur.png",
      badges: ["Wired", "Black"],
      orderId: "#OD24321",
      quantity: 1,
      price: 32400,
      originalPrice: 32400,
      isDiscounted: false
    }
  ];

  const orderSummary = {
    subtotal: 195000,
    reduction: 1000,
    shipping: 2500,
    tax: 5000,
    total: 210000
  };

  const clientDetails = {
    name: "Travis Adam",
    email: "travis_ad@mail.com",
    phone: "+22 6141 234 567"
  };

  const shippingDetails = {
    type: "Domicile",
    company: "travis_ad@mail.com",
    trackingNumber: "O12022311P"
  };

  const addresses = {
    billing: "U2186 Joyce Street Rocky Mount California - 24567, USA",
    shipping: "U2186 Joyce Street Rocky Mount California - 24567, USA"
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="flex justify-between items-start mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Commandes
            <div className="w-16 h-0.5 bg-orange-500 mt-2"></div>
          </h1>
          <div className="text-sm text-gray-600">
            <Link to="/dashboard" className="text-orange-500 hover:text-orange-600">
              Tableau de bord
            </Link>
            <span className="mx-2">{'>'}</span>
            <Link to="/dashboard/orders" className="text-orange-500 hover:text-orange-600">
              Commandes
            </Link>
            <span className="mx-2">{'>'}</span>
            <span>Detail Commande</span>
          </div>
        </div>
        
        {/* Action Bar */}
        <div className="flex items-center gap-4">
          {/* Status Dropdown */}
          <div className="relative">
            <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50">
              <span className="text-gray-700">{orderStatus}</span>
              <svg className="w-4 h-4 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                <path d="M7 10l5 5 5-5z"/>
              </svg>
            </button>
          </div>

          {/* Chat Icon */}
          <button className="p-2 text-gray-400 hover:text-gray-600">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
          </button>

          {/* Invoice Button */}
          <Link to={`/dashboard/orders/${orderId || 'OD24321'}/invoice`} className="flex items-center gap-2 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Facture
          </Link>
        </div>
      </div>

      {/* Order Identifier and Status Bar */}
      <div className="flex justify-between items-center mb-8 p-4 bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="flex items-center gap-4">
          <div>
            <h2 className="text-xl font-bold text-gray-900">#{orderId || 'OD24321'}</h2>
            <p className="text-sm text-gray-500">3 Product</p>
          </div>
          <span className="inline-flex px-3 py-1 text-sm font-medium rounded-full bg-orange-100 text-orange-800">
            {orderStatus}
          </span>
          <button className="text-gray-400 hover:text-gray-600">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          </button>
        </div>
        <div className="text-sm text-gray-500">
          14 janvier 2024, 10h14
        </div>
      </div>

      {/* Main Content - Two Columns */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Left Column - Order Items and Summary */}
        <div className="lg:col-span-2 space-y-6">
          {/* Order Items */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Articles de commande</h3>
            <div className="space-y-4">
              {orderItems.map((item) => (
                <div key={item.id} className="flex items-center gap-4 p-4 border border-gray-200 rounded-lg">
                  <input type="checkbox" className="rounded border-gray-300 text-orange-500 focus:ring-orange-500" />
                  <img src={item.image} alt={item.name} className="w-16 h-16 rounded-lg object-cover" />
                  <div className="flex-1">
                    <h4 className="font-medium text-gray-900">{item.name}</h4>
                    <div className="flex gap-2 mt-1">
                      {item.badges.map((badge, index) => (
                        <span key={index} className="px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded">
                          {badge}
                        </span>
                      ))}
                    </div>
                    <p className="text-sm text-gray-500 mt-1">{item.orderId}</p>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-gray-900">
                      {item.quantity} x {item.originalPrice.toLocaleString()} FCFA
                    </div>
                    {item.isDiscounted && (
                      <div className="text-sm text-gray-400 line-through">
                        {item.originalPrice.toLocaleString()} FCFA
                      </div>
                    )}
                    <div className="text-sm font-medium text-red-600">
                      {item.price.toLocaleString()} FCFA
                    </div>
                  </div>
                  <button className="text-gray-400 hover:text-red-600">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Order Summary */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Résumé de la commande</h3>
            
            {/* Payment Method */}
            <div className="flex justify-between items-center py-3 border-b border-gray-200">
              <span className="text-gray-600">Mode de paiement</span>
              <div className="flex items-center gap-2">
                <img src="/images/visa.png" alt="Visa" className="w-6 h-6" />
                <span className="text-gray-900">Visa *9021</span>
              </div>
            </div>

            {/* Financial Breakdown */}
            <div className="space-y-3 mt-4">
              <div className="flex justify-between">
                <span className="text-gray-600">Total</span>
                <span className="text-gray-900">{orderSummary.subtotal.toLocaleString()} FCFA</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Reduction</span>
                <span className="text-green-600">-{orderSummary.reduction.toLocaleString()} FCFA</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Livraison</span>
                <span className="text-gray-900">{orderSummary.shipping.toLocaleString()} FCFA</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Tax (5%)</span>
                <span className="text-gray-900">{orderSummary.tax.toLocaleString()} FCFA</span>
              </div>
              <div className="flex justify-between pt-3 border-t border-gray-200">
                <span className="font-bold text-gray-900">Total</span>
                <span className="font-bold text-gray-900">{orderSummary.total.toLocaleString()} FCFA</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Client Details, Shipping, Address */}
        <div className="space-y-6">
          {/* Client Details */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Détails du client</h3>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <div>
                  <p className="text-sm text-gray-500">Nom</p>
                  <p className="text-gray-900">{clientDetails.name}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <div>
                  <p className="text-sm text-gray-500">Adresse mail</p>
                  <p className="text-gray-900">{clientDetails.email}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <div>
                  <p className="text-sm text-gray-500">Telephone</p>
                  <p className="text-gray-900">{clientDetails.phone}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Shipping */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Expédition</h3>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                </svg>
                <div>
                  <p className="text-sm text-gray-500">Expédition</p>
                  <p className="text-gray-900">{shippingDetails.type}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                <div>
                  <p className="text-sm text-gray-500">Entreprise</p>
                  <p className="text-gray-900">{shippingDetails.company}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
                </svg>
                <div>
                  <p className="text-sm text-gray-500">Numéro</p>
                  <p className="text-gray-900">{shippingDetails.trackingNumber}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Address */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Address</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <svg className="w-5 h-5 text-gray-400 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <div>
                  <p className="text-sm text-gray-500">Adresse de facturation</p>
                  <p className="text-gray-900">{addresses.billing}</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <svg className="w-5 h-5 text-gray-400 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <div>
                  <p className="text-sm text-gray-500">Adresse de livraison</p>
                  <p className="text-gray-900">{addresses.shipping}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetail;
